export default __webpack_public_path__ + "static/media/related-product-01.3c97d565.jpg";